document.addEventListener('DOMContentLoaded', function() {
  function updateDistanceToTop() {
    const dropdownPlusMenus = document.querySelectorAll('.header__submenu__plus');
    
    dropdownPlusMenus.forEach((menu, index) => {
      // Get the parent details element
      let submenu_offset = 0;
      let positionTop = -1;
      let parentDetails = menu.closest('.site-nav__deep-dropdown-trigger');
      if (!parentDetails) return;

      // get parentDetails position in closest ul
      const parentUl = parentDetails.closest('ul');
      if (!parentUl) return;

      const allItems = Array.from(parentUl.children);
      const position = allItems.indexOf(parentDetails) + 1; // 1-based position
      const menuItems = menu.querySelectorAll('li').length;

      if(position >= 4) {
        const i = position + menuItems - 7 - 1;
        const max_offset = position - 2;
        submenu_offset = Math.min(i, max_offset);
      }


      if(submenu_offset > 0) {
        const parentLi = parentDetails;
        
        // Start with the parent li
        let siblingLi = parentLi;
      
        
        // Go up by submenu_offset positions
        for (let i = 0; i < submenu_offset; i++) {
          const previousSibling = siblingLi.previousElementSibling;
          if (previousSibling) {
            siblingLi = previousSibling;
          } else {
            break; // Stop if we reach the top of the list
          }
        }
        
        
        const siblingDetails = siblingLi;
        
        // If we found a sibling details element, use it for offset calculation
        if (siblingDetails) {
          parentDetails = siblingDetails;
        }
        positionTop = -1 * (submenu_offset * 43 + 1);
      }
      
      // Calculate distance from the top of the viewport
      const rect = parentDetails.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = rect.top + scrollTop;

      
      // Set the custom property on the menu element
      menu.style.setProperty('--distance-to-top', `${offsetTop}px`);
      menu.style.setProperty('--position-top', `${positionTop}px`);
    });
  }
  
  // Run initially
  updateDistanceToTop();
  
  // Update on window resize for responsive layouts
  window.addEventListener('resize', updateDistanceToTop);
  
  // Update when details are toggled, as this can change positions
  document.querySelectorAll('details').forEach(details => {
    details.addEventListener('toggle', function() {
      // Small delay to allow the toggle animation to complete
      setTimeout(updateDistanceToTop, 10);
    });
  });
});